/* eslint-disable curly */
import React, { useRef, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
  StatusBar,
  Linking,
  Dimensions,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { WebView } from "react-native-webview";

import styles from "./styles";
import { validarDataNascimento } from "../../../services/aluno-service";
import ButtonConfirm from "../../../components/ButtonConfirm";
import Loading from "../../../components/Loading";
import { TextInputMask } from "react-native-masked-text";
import { onSignIn } from "../../../services/auth-service";

function TermoDeUso({ navigation }) {
  const inputData = useRef();

  const [textButton, setTextButton] = useState(
    Platform.OS === "web" ? "Continuar" : ""
  );
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [loading, setLoading] = useState(Platform.OS === "web" ? false : true);
  const [aceite, setAceite] = useState(false);
  const [abriuTermo, setAbriuTermo] = useState(false);

  const prosseguir = async () => {
    let aluno = navigation.getParam("aluno");

    return navigation.navigate("ValidarDataNascimento", {
      aluno: aluno,
    });
  };

  const openLinkWeb = () => {
    window.open("https://senai-job.netlify.app/termo-uso-aluno.html", "_blank");
    setAbriuTermo(true);
  };

  const handlerAceite = () => {
    if (Platform.OS === "web" && !abriuTermo) {
      openLinkWeb();
    }
    setAceite(!aceite);
  };

  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.OS === "ios" ? "padding" : "null"}
        enabled
      >
        <ImageBackground
          source={require("../../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={styles.containerForm}>
            <TouchableOpacity
              style={styles.iconClose}
              onPress={() => {
                // StatusBar.setBackgroundColor("#F00");
                navigation.pop(1);
              }}
            >
              <Icon name={"close"} size={30} color="#FFF" />
            </TouchableOpacity>
            <Text style={styles.textHeader1}>Olá, bom te ver por aqui</Text>
            <Text style={styles.textHeader2}>
              Para continuarmos é preciso que você aceite nossos temos de uso
            </Text>
            {Platform.OS === "web" ? (
              <TouchableOpacity onPress={openLinkWeb}>
                <Text
                  style={[
                    styles.textHeader2,
                    { fontSize: 16, marginBottom: 0, padding: 4 },
                  ]}
                >
                  Abrir termo ->
                </Text>
              </TouchableOpacity>
            ) : (
              <WebView
                onLoadStart={() => setLoading(true)}
                onLoadProgress={() => setTextButton("Carregando...")}
                onLoadEnd={() => {
                  setLoading(false);
                  setTextButton("Continuar");
                  // setTimeout(() => {
                  //   setConfirmDisabled(false);
                  // }, 3000);
                }}
                source={{
                  uri: "https://senai-job.netlify.app/termo-uso-aluno.html",
                }}
                onScroll={(e) => {
                  // const scrollEnd = parseInt(
                  //   e.nativeEvent.contentSize.height -
                  //     e.nativeEvent.layoutMeasurement.height
                  // );
                  // const scrollY = parseInt(e.nativeEvent.contentOffset.y);
                  // if (scrollY === scrollEnd) {
                  //   setConfirmDisabled(false);
                  // }
                }}
                style={{
                  flex: 1,
                  width: Dimensions.get("window").width - 20,
                  height: 100,
                  backgroundColor: "#CCC5",
                  marginTop: 10,
                }}
              />
            )}

            <TouchableOpacity
              style={{
                height: 38,
                flexDirection: "row",
                marginVertical: 10,
                margin: 10,
                alignItems: "center",
              }}
              onPress={handlerAceite}
            >
              <View
                style={{
                  width: 30,
                  height: 30,
                  backgroundColor: "#DDD",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 6,
                }}
              >
                {aceite && (
                  <Icon
                    name={"check"}
                    size={25}
                    color="#0A0"
                    style={{
                      width: 25,
                      height: 25,
                      borderRadius: 13,
                    }}
                  />
                )}
              </View>
              <Text
                style={[
                  styles.textHeader2,
                  { fontSize: 16, marginBottom: 0, padding: 4 },
                ]}
              >
                Sim, aceito os termos de uso.
              </Text>
            </TouchableOpacity>
            <ButtonConfirm
              text={textButton}
              disabled={!aceite}
              onPress={prosseguir}
              msgDisabled="É preciso que você leia e aceite os temos de uso"
            />
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
}

export default TermoDeUso;
